import { render } from "./RowCheckbox.vue?vue&type=template&id=766273c2"
import script from "./RowCheckbox.vue?vue&type=script&lang=js"
export * from "./RowCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__